import { defineComponent } from "vue";

import { COMPONENT_NAME } from "./attributes";

export default defineComponent({
  name: COMPONENT_NAME,
  data() {
    return {
      userRepo: this.$projectServices.userRepo,
    };
  },
  props: {
    view: {
      type: String,
      default: "",
    },
  },
  computed: {
    notVerified(): boolean {
      return !this.userRepo.isVerified;
    },
  },
});
